/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiIdentityCookieconsentGet } from '../fn/cookie-consent/api-identity-cookieconsent-get';
import { ApiIdentityCookieconsentGet$Params } from '../fn/cookie-consent/api-identity-cookieconsent-get';
import { apiIdentityCookieconsentGet$Plain } from '../fn/cookie-consent/api-identity-cookieconsent-get-plain';
import { ApiIdentityCookieconsentGet$Plain$Params } from '../fn/cookie-consent/api-identity-cookieconsent-get-plain';
import { apiIdentityCookieconsentPut } from '../fn/cookie-consent/api-identity-cookieconsent-put';
import { ApiIdentityCookieconsentPut$Params } from '../fn/cookie-consent/api-identity-cookieconsent-put';
import { apiIdentityCookieconsentPut$Plain } from '../fn/cookie-consent/api-identity-cookieconsent-put-plain';
import { ApiIdentityCookieconsentPut$Plain$Params } from '../fn/cookie-consent/api-identity-cookieconsent-put-plain';
import { CookieConsentCustomerDto } from '../models/cookie-consent-customer-dto';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class CookieConsentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiIdentityCookieconsentGet()` */
  static readonly ApiIdentityCookieconsentGetPath = '/api/identity/cookieconsent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityCookieconsentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityCookieconsentGet$Plain$Response(params?: ApiIdentityCookieconsentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieConsentCustomerDto>> {
    return apiIdentityCookieconsentGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityCookieconsentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityCookieconsentGet$Plain(params?: ApiIdentityCookieconsentGet$Plain$Params, context?: HttpContext): Observable<CookieConsentCustomerDto> {
    return this.apiIdentityCookieconsentGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CookieConsentCustomerDto>): CookieConsentCustomerDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityCookieconsentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityCookieconsentGet$Response(params?: ApiIdentityCookieconsentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieConsentCustomerDto>> {
    return apiIdentityCookieconsentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityCookieconsentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityCookieconsentGet(params?: ApiIdentityCookieconsentGet$Params, context?: HttpContext): Observable<CookieConsentCustomerDto> {
    return this.apiIdentityCookieconsentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CookieConsentCustomerDto>): CookieConsentCustomerDto => r.body)
    );
  }

  /** Path part for operation `apiIdentityCookieconsentPut()` */
  static readonly ApiIdentityCookieconsentPutPath = '/api/identity/cookieconsent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityCookieconsentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityCookieconsentPut$Plain$Response(params?: ApiIdentityCookieconsentPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityCookieconsentPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityCookieconsentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityCookieconsentPut$Plain(params?: ApiIdentityCookieconsentPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityCookieconsentPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityCookieconsentPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityCookieconsentPut$Response(params?: ApiIdentityCookieconsentPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityCookieconsentPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityCookieconsentPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityCookieconsentPut(params?: ApiIdentityCookieconsentPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityCookieconsentPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

}
